// Available currencies with symbols
export const currencies = {
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'JPY': '¥',
  'CNY': '¥',
  'INR': '₹',
  'BRL': 'R$',
  'RUB': '₽',
  'KRW': '₩',
  'AUD': 'A$',
  'CAD': 'C$',
  'CHF': 'CHF',
  'SEK': 'kr',
  'NOK': 'kr',
  'DKK': 'kr',
  'PLN': 'zł',
  'CZK': 'Kč',
  'HUF': 'Ft',
  'RON': 'lei',
  'BGN': 'лв',
  'HRK': 'kn',
  'RSD': 'дин',
  'ALL': 'L',
  'BAM': 'KM',
  'MKD': 'ден',
  'MDL': 'L',
  'UAH': '₴',
  'BYN': 'Br',
  'AMD': '֏',
  'GEL': '₾',
  'AZN': '₼',
  'KZT': '₸',
  'KGS': 'с',
  'TJS': 'ЅМ',
  'TMT': 'T',
  'UZS': 'so\'m',
  'LAK': '₭',
  'KHR': '៛',
  'THB': '฿',
  'VND': '₫',
  'IDR': 'Rp',
  'MYR': 'RM',
  'SGD': 'S$',
  'BDT': '৳',
  'LKR': 'Rs',
  'NPR': '₨',
  'MMK': 'K',
  'KES': 'KSh',
  'TZS': 'TSh',
  'UGX': 'USh',
  'NGN': '₦',
  'GHS': '₵',
  'ZAR': 'R',
  'NAD': 'N$',
  'BWP': 'P',
  'ZMW': 'ZK',
  'MWK': 'MK',
  'ZWL': 'Z$',
  'ETB': 'Br',
  'SDG': 'ج.س',
  'EGP': 'E£',
  'LYD': 'ل.د',
  'TND': 'د.ت',
  'DZD': 'د.ج',
  'MAD': 'د.م',
  'MRU': 'UM',
  'XOF': 'CFA',
  'XAF': 'FCFA',
  'XPF': 'CFP',
  'STN': 'Db',
  'CVE': '$',
  'GMD': 'D',
  'LRD': 'L$',
  'SLL': 'Le',
  'GNF': 'FG',
  'IRR': '﷼',
  'IQD': 'ع.د',
  'JOD': 'د.ا',
  'LBP': 'ل.ل',
  'SYP': 'ل.س',
  'YER': '﷼',
  'OMR': 'ر.ع',
  'QAR': 'ر.ق',
  'SAR': 'ر.س',
  'AED': 'د.إ',
  'BHD': 'د.ب',
  'KWD': 'د.ك',
};

// Function to format price with currency
export const formatPrice = (price, currency = 'USD') => {
  const symbol = currencies[currency] || currency;
  const numericPrice = parseFloat(price) || 0;
  return `${symbol} ${numericPrice.toFixed(2)}`;
};

// Function to get currency symbol
export const getCurrencySymbol = (currency = 'USD') => {
  return currencies[currency] || currency;
}; 